import { render, staticRenderFns } from "./TCBreadcrumbRouter.vue?vue&type=template&id=05adae6d&"
import script from "./TCBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./TCBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports